import React from 'react';
import  ReactDOM  from 'react-dom';

import App from './App';
import './index.css';

//* creating entire react application inside div with id root in public index.js
ReactDOM.render(<App />, document.getElementById('root'));